/**
 * Visual tokens that evoke Autodesk Forma's surface. These are
 * scoped to the Forma view via inline styles — the rest of Vera's
 * dark theme stays untouched. Sourced from the Forma Requirements
 * Intelligence mockup (vera_requirements_intelligence_plan_actualized_clean.svg).
 *
 * Cosmetic only: nothing here ships into Forma; the mockup just
 * needs to LOOK like Forma for the pitch.
 */

export const FORMA = {
  // Surfaces
  pageBg: "#f7f8fa",
  panelBg: "#ffffff",
  topBarBg: "#050505",
  borderSoft: "#e3e7ec",
  borderHard: "#d4d9e1",

  // Typography
  textPrimary: "#111827",
  textSecondary: "#374151",
  textMuted: "#6b7280",
  textDim: "#9aa3af",

  // Accents
  blue: "#0a72e8",
  blueSoftBg: "#e7f1ff",
  greenSoftBg: "#dff3e5",
  greenText: "#087339",
  redText: "#dc2626",
  redSoftBg: "#fee2e2",
  amberText: "#f59e0b",
  amberSoftBg: "#fff7ed",
} as const;
